import React from "react";
import PropTypes from 'prop-types';

import "./WhatHappensNext.css";

import { Heading, Text, Subtitle } from "./../../../StyledComponents";
import InstallationIcon from "../../Common/Svg/InstallationIcon";
import ActivationIcon from "../../Common/Svg/ActivationIcon";
import DeliveryIcon from "../../Common/Svg/DeliveryIcon";
import DeactivateIcon from "../../Common/Svg/DeactivateIcon";

const WhatHappensNext = (props) => {
  let isLte = false;
  props.additionalServices.forEach(additionalService => {
    isLte = additionalService.serviceKey === "lte" ? true : isLte;
  });

  return (
    <div>
    {
      isLte ?
        <div
          className="new-customer-success__what-happens-next"
          automationid="SalesLead_Div_WHN_1"
        >
          <div
            style={{ textAlign: "left" }}
            className="success-screen__data"
            automationid="SalesLead_Div_WHN_2"
          >
            <Heading automationid="SalesLead_H1_WHN_1">What happens next?</Heading>

            <div className="success-activity-wrapper">
              <span style={{ marginRight: "10px" }}><DeliveryIcon /></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_1"
                marginTop="0"
              >
                LTE Delivery
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_1">
              We&apos;ll deliver your LTE router to your installation address.
            </Text>

            <div
              className="success-screen__dash"
              style={{ margin: "2.5rem 0" }}
              automationid="SalesLead_Div_WHN_3"
            ></div>

            <div className="success-activity-wrapper">
              <span style={{marginRight: "10px"}}><InstallationIcon/></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_2"
                marginTop = "0"
              >
                Installation
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_2">
              New fibre line? Expect a call about installation, within two weeks.
              Already got fibre installed? Our team will get in touch regarding
              service activation.
            </Text>

            <div
              className="success-screen__dash"
              style={{ margin: "2.5rem 0" }}
              automationid="SalesLead_Div_WHN_4"
            ></div>

            <div className="success-activity-wrapper">
              <span style={{ marginRight: "10px" }}><ActivationIcon /></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_3"
                marginTop="0"
              >
                Activation
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_3">
              RAM Couriers will deliver your router. Once fibre has been installed,
              plug the router into the fibre box (ONT) and the service will
              auto-activate in about 10 minutes. Simply follow the instructions on
              the box or call 082 1904 if you need help.
            </Text>

            <div
              className="success-screen__dash"
              style={{ margin: "2.5rem 0" }}
              automationid="SalesLead_Div_WHN_5"
            ></div>

            <div className="success-activity-wrapper">
              <span style={{ marginRight: "10px" }}><DeactivateIcon /></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_4"
                marginTop="0"
              >
                Deactivate LTE
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_4">
              Once fibre is up and running, the LTE service will stop and you’ll pay for the fibre line instead.
            </Text>
          </div>
          
        </div>
      :
        <div
          className="new-customer-success__what-happens-next"
          automationid="SalesLead_Div_WHN_1"
        >
          <div
            style={{ textAlign: "left" }}
            className="success-screen__data"
            automationid="SalesLead_Div_WHN_2"
          >
            <Heading automationid="SalesLead_H1_WHN_1">What happens next?</Heading>
            
            <div className="success-activity-wrapper">
              <span style={{marginRight: "10px"}}><InstallationIcon/></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_1"
                marginTop = "0"
              >
                Installation
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_1">
              New fibre line? Expect a call about installation, within two weeks.
              Already got fibre installed? Our team will get in touch regarding
              service activation.
            </Text>

            <div
              className="success-screen__dash"
              style={{ margin: "2.5rem 0" }}
              automationid="SalesLead_Div_WHN_3"
            ></div>

            <div className="success-activity-wrapper">
              <span style={{ marginRight: "10px" }}><ActivationIcon /></span>
              <Subtitle 
                automationid="SalesLead_H3_WHN_2"
                marginTop="0"
              >
                Activation
              </Subtitle>
            </div>
            <Text color="black" automationid="SalesLead_P_WHN_2">
              RAM Couriers will deliver your router. Once fibre has been installed,
              plug the router into the fibre box (ONT) and the service will
              auto-activate in about 10 minutes. Simply follow the instructions on
              the box or call 082 1904 if you need help.
            </Text>
          </div>
        </div>
    }
    </div>
  );
};

WhatHappensNext.propTypes = {
  additionalServices: PropTypes.arrayOf(PropTypes.shape({
    serviceKey: PropTypes.string
  }))
};

export default WhatHappensNext;
